"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRowKey = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/**
 * Copyright 2025 Scott Bender (scott@scottbender.net)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const react_1 = __importStar(require("react"));
const reactstrap_1 = require("reactstrap");
const rxjs_1 = require("rxjs");
const DataList_1 = require("./DataList");
const Filters_1 = require("./Filters");
const SentencePanel_1 = require("./SentencePanel");
const ConnectionManagerPanel_1 = require("./ConnectionManagerPanel");
const SendTab_1 = require("./SendTab");
const TransformTab_1 = __importDefault(require("./TransformTab"));
const RecordingTab_1 = __importDefault(require("./RecordingTab"));
const PgnBrowser_1 = require("./PgnBrowser");
const EditorTab_1 = __importStar(require("./EditorTab"));
const RecordingContext_1 = require("../contexts/RecordingContext");
const canboatjs_1 = require("@canboat/canboatjs");
const ts_pgns_1 = require("@canboat/ts-pgns");
const localStorage_1 = require("../utils/localStorage");
const services_1 = require("../services");
const aisPGNs = [129038, 129039, 129041, 129794, 129809, 130842, 129793, 129810];
const getRowKey = (pgn, options) => {
    const usePKs = aisPGNs.includes(pgn.pgn) === false || options?.showAISOnSeparateLines === true;
    let key = `${pgn.getDefinition().Id}-${pgn.pgn}-${pgn.src}}`;
    if (usePKs) {
        key = `${key}-${createFieldDataHash(pgn, true)}`;
    }
    if ((pgn.getDefinition().Fallback === true && options?.showUnknownProprietaryPGNsOnSeparateLines) ||
        (pgn.pgn === 126208 && options?.showPgn126208OnSeparateLines)) {
        const fieldHash = createFieldDataHash(pgn);
        key = `${key}-${fieldHash}`;
    }
    return key;
};
exports.getRowKey = getRowKey;
// Simple hash function for creating consistent hashes from field data
const createFieldDataHash = (pgn, primaryKeys = false) => {
    try {
        // Serialize the fields object to a stable string representation
        let serialized;
        if (primaryKeys) {
            const pkeys = pgn
                .getDefinition()
                .Fields.filter((field) => field.PartOfPrimaryKey === true)
                .map((field) => field.Id);
            if (pkeys.length === 0) {
                return '';
            }
            serialized = JSON.stringify(pgn.fields, (key, value) => {
                // Handle root object (empty key) - always include it
                if (key === '')
                    return value;
                // Only include properties that are primary keys
                return pkeys.indexOf(key) !== -1 ? value : undefined;
            });
        }
        else {
            serialized = JSON.stringify(pgn.fields, (key, value) => key !== 'data' && key !== 'input' && key !== 'rawData' && key !== 'byteMapping' ? value : undefined);
        }
        // Simple djb2 hash algorithm implementation
        let hash = 5381;
        for (let i = 0; i < serialized.length; i++) {
            hash = (hash << 5) + hash + serialized.charCodeAt(i);
            hash = hash >>> 0; // Convert to 32-bit unsigned integer
        }
        return hash.toString(16); // Return as hexadecimal string
    }
    catch (error) {
        console.warn('Failed to create field data hash:', error);
        return 'hash-error';
    }
};
const infoPGNS = [60928, 126998, 126996];
const SEND_TAB_ID = 'send';
const ANALYZER_TAB_ID = 'analyzer';
const TRANSFORM_TAB_ID = 'transform';
const RECORDING_TAB_ID = 'recording';
const CONNECTIONS_TAB_ID = 'connections';
const PGN_BROWSER_TAB_ID = 'pgn-browser';
const EDITING_TAB_ID = 'editing';
const AppPanelInner = (props) => {
    const { dispatch } = (0, RecordingContext_1.useRecording)();
    // Check if we're in embedded mode (SignalK plugin) vs standalone mode
    const isEmbedded = typeof window !== 'undefined' && window.location.href.includes('/admin/');
    const [activeTab, setActiveTab] = (0, react_1.useState)(() => {
        const savedTab = localStorage_1.tabStorage.getActiveTab();
        // Validate the saved tab - if in embedded mode, don't allow connections tab
        if (savedTab && (savedTab !== CONNECTIONS_TAB_ID || !isEmbedded)) {
            const validTabs = [
                ANALYZER_TAB_ID,
                SEND_TAB_ID,
                TRANSFORM_TAB_ID,
                RECORDING_TAB_ID,
                PGN_BROWSER_TAB_ID,
                EDITING_TAB_ID,
            ];
            if (!isEmbedded) {
                validTabs.push(CONNECTIONS_TAB_ID);
            }
            return validTabs.includes(savedTab) ? savedTab : ANALYZER_TAB_ID;
        }
        return ANALYZER_TAB_ID;
    });
    const [ws, setWs] = (0, react_1.useState)(null);
    const [data] = (0, react_1.useState)(new rxjs_1.ReplaySubject());
    const [list, setList] = (0, react_1.useState)({});
    const [selectedPgn] = (0, react_1.useState)(new rxjs_1.ReplaySubject());
    const [selectedPgnWithHistory] = (0, react_1.useState)(new rxjs_1.ReplaySubject());
    const [selectedPgnKey, setSelectedPgnKey] = (0, react_1.useState)(null);
    const selectedPgnKeyRef = (0, react_1.useRef)(null);
    const [doFiltering] = (0, react_1.useState)(new rxjs_1.ReplaySubject());
    const [filter] = (0, react_1.useState)(new rxjs_1.ReplaySubject());
    const [filterOptions] = (0, react_1.useState)(new rxjs_1.ReplaySubject());
    const [availableSrcs] = (0, react_1.useState)(new rxjs_1.ReplaySubject());
    const [currentSrcs, setCurrentSrcs] = (0, react_1.useState)([]);
    const [deviceInfo] = (0, react_1.useState)(new rxjs_1.ReplaySubject());
    const [currentInfo, setCurrentInfo] = (0, react_1.useState)({});
    const [connectionStatus, setConnectionStatus] = (0, react_1.useState)({
        isConnected: false,
        lastUpdate: new Date().toISOString(),
        error: undefined,
    });
    const [authStatus, setAuthStatus] = (0, react_1.useState)({
        isAuthenticated: false,
        isAdmin: false,
        loading: true,
    });
    const sentInfoReq = [];
    const [outAvailable, setOutAvailable] = (0, react_1.useState)(false);
    const outAvailableRef = (0, react_1.useRef)(false);
    const [showDataList, setShowDataList] = (0, react_1.useState)(() => localStorage_1.dataListStorage.getVisibility());
    let sentReqAll = false;
    // Add throttling for data processing to prevent event loop blocking
    const pendingDataUpdates = (0, react_1.useRef)([]);
    const dataUpdateTimeoutRef = (0, react_1.useRef)(null);
    const processPendingDataUpdates = (0, react_1.useCallback)(() => {
        if (pendingDataUpdates.current.length === 0) {
            return;
        }
        const updates = [...pendingDataUpdates.current];
        pendingDataUpdates.current = [];
        // Process all pending updates in a single batch
        updates.forEach((pgn) => {
            if (infoPGNS.indexOf(pgn.pgn) === -1 || filterOptionsRef.current?.showInfoPgns) {
                setList((prev) => {
                    const rowKey = (0, exports.getRowKey)(pgn, filterOptionsRef.current || undefined);
                    const maxHistorySize = filterOptionsRef.current?.maxHistorySize ?? 10;
                    if (prev[rowKey]) {
                        // Move current to history and update current
                        let newHistory = [prev[rowKey].current, ...prev[rowKey].history];
                        // Limit history size if maxHistorySize > 0, otherwise disable history
                        if (maxHistorySize === 0) {
                            newHistory = [];
                        }
                        else if (newHistory.length > maxHistorySize) {
                            newHistory = newHistory.slice(0, maxHistorySize);
                        }
                        prev[rowKey] = {
                            current: pgn,
                            history: newHistory,
                        };
                    }
                    else {
                        // New entry
                        prev[rowKey] = {
                            current: pgn,
                            history: [],
                        };
                    }
                    // Check if this update corresponds to the currently selected PGN
                    if (selectedPgnKeyRef.current === rowKey) {
                        selectedPgn.next(pgn);
                        selectedPgnWithHistory.next({
                            current: pgn,
                            history: prev[rowKey].history,
                        });
                    }
                    return prev;
                });
            }
            if (currentSrcs.indexOf(pgn.src) === -1) {
                setCurrentSrcs((prev) => {
                    prev.push(pgn.src);
                    availableSrcs.next([...prev.sort((a, b) => a - b)]);
                    return prev;
                });
            }
            if (infoPGNS.indexOf(pgn.pgn) !== -1) {
                setCurrentInfo((prev) => {
                    prev[pgn.src] = prev[pgn.src] || { src: pgn.src, info: {} };
                    prev[pgn.src].info[pgn.pgn] = pgn;
                    deviceInfo.next({ ...prev });
                    return prev;
                });
            }
            if (sentInfoReq.indexOf(pgn.src) === -1) {
                if (outAvailableRef.current) {
                    sentInfoReq.push(pgn.src);
                    // NMEA output is available, can request metadata immediately
                    requestMetaData(pgn.src);
                }
                // If outAvailable is false, we simply don't request metadata yet
            }
        });
        // Trigger data update after processing all items
        setList((prev) => {
            data.next({ ...prev });
            return prev;
        });
    }, []);
    // Handler for tab changes with persistence
    const handleTabChange = (tabId) => {
        setActiveTab(tabId);
        localStorage_1.tabStorage.setActiveTab(tabId);
    };
    // Handler for DataList visibility toggle
    const handleDataListToggle = () => {
        const newVisibility = !showDataList;
        setShowDataList(newVisibility);
        localStorage_1.dataListStorage.setVisibility(newVisibility);
    };
    // Handler for editing PGN from PgnBrowser
    const handleEditPgn = (definition, pgnData) => {
        // Save the definition for editing
        (0, EditorTab_1.saveDefinition)(definition, pgnData);
        // Switch to the Editing tab
        handleTabChange(EDITING_TAB_ID);
    };
    // Make debugging functions available globally
    react_1.default.useEffect(() => {
        if (typeof window !== 'undefined') {
            // Also make authentication status available for debugging
            ;
            window.getAuthStatus = () => authStatus;
            window.forceAuthCheck = () => {
                if (isEmbedded) {
                    // Force re-check authentication
                    setAuthStatus((prev) => ({ ...prev, loading: true }));
                    // The useEffect will re-run the authentication check
                }
            };
        }
    }, [authStatus, isEmbedded]);
    // Check authentication status when in embedded mode
    (0, react_1.useEffect)(() => {
        const checkAuthentication = async () => {
            if (!isEmbedded) {
                // In standalone mode, skip authentication check
                setAuthStatus({
                    isAuthenticated: true,
                    isAdmin: true,
                    loading: false,
                });
                return;
            }
            try {
                console.log('Checking authentication status...');
                const response = await fetch('/skServer/loginStatus');
                if (response.ok) {
                    const loginStatus = await response.json();
                    console.log('Login status received:', loginStatus);
                    const isAuthenticated = loginStatus.status === 'loggedIn';
                    const isAdmin = loginStatus.userLevel === 'admin';
                    setAuthStatus({
                        isAuthenticated,
                        isAdmin,
                        username: loginStatus.username,
                        loading: false,
                        error: !isAuthenticated ? 'Not logged in' : !isAdmin ? 'Admin access required' : undefined,
                    });
                    if (!isAuthenticated) {
                        console.warn('User is not logged in');
                    }
                    else if (!isAdmin) {
                        console.warn('User does not have admin privileges');
                    }
                    else {
                        console.log('User authenticated with admin privileges');
                    }
                }
                else {
                    throw new Error(`Authentication check failed: ${response.status}`);
                }
            }
            catch (error) {
                console.error('Failed to check authentication:', error);
                setAuthStatus({
                    isAuthenticated: false,
                    isAdmin: false,
                    loading: false,
                    error: `Authentication check failed: ${error instanceof Error ? error.message : 'Unknown error'}`,
                });
            }
        };
        checkAuthentication();
    }, [isEmbedded]);
    const [parser, setParser] = (0, react_1.useState)(null);
    const parserRef = (0, react_1.useRef)(null);
    const filterOptionsRef = (0, react_1.useRef)(null);
    // Initialize parser once
    (0, react_1.useEffect)(() => {
        if (!parser) {
            const initialParser = new canboatjs_1.FromPgn({
                returnNulls: true,
                checkForInvalidFields: true,
                useCamel: true, // Default value
                useCamelCompat: false,
                returnNonMatches: true,
                createPGNObjects: true,
                includeInputData: true,
                includeRawData: true,
                includeByteMapping: true,
            });
            initialParser.on('error', (pgn, error) => {
                console.error(`Error parsing ${pgn.pgn} ${error}`);
                //console.error(error.stack)
            });
            setParser(initialParser);
            parserRef.current = initialParser;
        }
    }, [parser]);
    // Update parser options when filterOptions change
    (0, react_1.useEffect)(() => {
        const subscription = filterOptions.subscribe((options) => {
            if (parserRef.current) {
                // Update parser options instead of recreating the parser
                //parserRef.current.options.useCamel = options?.useCamelCase ?? true
                filterOptionsRef.current = options;
            }
        });
        return () => subscription.unsubscribe();
    }, [filterOptions]);
    // Keep selectedPgnKeyRef in sync with selectedPgnKey state
    (0, react_1.useEffect)(() => {
        selectedPgnKeyRef.current = selectedPgnKey;
    }, [selectedPgnKey]);
    const deleteAllKeys = (obj) => {
        Object.keys(obj).forEach((key) => {
            delete obj[key];
        });
    };
    // Load initial connection status from server
    (0, react_1.useEffect)(() => {
        const loadInitialStatus = async () => {
            try {
                const response = await fetch('/api/config');
                if (response.ok) {
                    const config = await response.json();
                    const initialStatus = {
                        isConnected: config.connection?.isConnected || false,
                        lastUpdate: config.connection?.lastUpdate || new Date().toISOString(),
                        error: config.connection?.error || undefined, // Include any persisted error
                    };
                    setConnectionStatus(initialStatus);
                }
            }
            catch (error) {
                console.error('Failed to load initial connection status:', error);
                setConnectionStatus((prev) => ({
                    ...prev,
                    error: `Failed to load configuration: ${error instanceof Error ? error.message : 'Unknown error'}`,
                    lastUpdate: new Date().toISOString(),
                }));
            }
        };
        // Only load initial status in standalone mode (not embedded)
        if (!isEmbedded) {
            loadInitialStatus();
        }
    }, [isEmbedded]);
    (0, react_1.useEffect)(() => {
        let webSocket = null;
        let reconnectTimeout = null;
        const handleWebSocketMessage = (messageData) => {
            try {
                const parsed = JSON.parse(messageData);
                //console.log('Parsed WebSocket event:', parsed.event, parsed)
                if (isEmbedded && sentReqAll === false) {
                    sentReqAll = true;
                    setOutAvailable(true);
                    outAvailableRef.current = true;
                    requestMetaData(255);
                }
                // Handle connection status events
                if (parsed.event === 'nmea:connected') {
                    // Clear all data when reconnecting
                    console.log('NMEA connection established');
                    setList((prev) => {
                        data.next({});
                        deleteAllKeys(prev);
                        return prev;
                    });
                    setCurrentSrcs((prev) => {
                        availableSrcs.next([]);
                        prev.length = 0;
                        return prev;
                    });
                    setCurrentInfo((prev) => {
                        deviceInfo.next([]);
                        deleteAllKeys(prev);
                        return prev;
                    });
                    // Clear selected PGN when connection resets
                    setSelectedPgnKey(null);
                    sentInfoReq.length = 0;
                    // Reset out available when reconnecting
                    setOutAvailable(false);
                    outAvailableRef.current = false;
                    setConnectionStatus({
                        isConnected: true,
                        lastUpdate: new Date().toISOString(),
                        error: undefined, // Clear any previous errors
                    });
                    return;
                }
                if (parsed.event === 'nmea:out-available') {
                    console.log('NMEA output available - can now request metadata');
                    setOutAvailable(true);
                    outAvailableRef.current = true;
                    requestMetaData(255);
                    return;
                }
                if (parsed.event === 'nmea:disconnected') {
                    console.log('NMEA connection lost');
                    setOutAvailable(false);
                    outAvailableRef.current = false;
                    setConnectionStatus((prev) => ({
                        isConnected: false,
                        lastUpdate: new Date().toISOString(),
                        error: undefined, // Disconnection isn't necessarily an error
                    }));
                    return;
                }
                // Handle error events that might affect connection status
                if (parsed.event === 'error') {
                    console.error('NMEA connection error received via WebSocket:', parsed.error);
                    setConnectionStatus((prev) => ({
                        ...prev,
                        isConnected: false,
                        error: parsed.error || 'Unknown connection error',
                        lastUpdate: new Date().toISOString(),
                    }));
                    return;
                }
                // Handle recording events
                if (parsed.event === 'recording:started') {
                    // Recording started event
                    console.log('Recording started:', parsed.data);
                    dispatch({ type: 'RECORDING_STARTED', payload: parsed.data });
                    return;
                }
                if (parsed.event === 'recording:stopped') {
                    // Recording stopped event
                    console.log('Recording stopped:', parsed.data);
                    dispatch({ type: 'RECORDING_STOPPED', payload: parsed.data });
                    return;
                }
                if (parsed.event === 'recording:progress') {
                    // Recording progress event
                    //console.log('Recording progress:', parsed.data)
                    dispatch({ type: 'RECORDING_PROGRESS', payload: parsed.data });
                    return;
                }
                if (parsed.event === 'recording:error') {
                    // Recording error event
                    console.error('Recording error:', parsed.data);
                    dispatch({ type: 'RECORDING_ERROR', payload: parsed.data });
                    return;
                }
                // Handle NMEA data events
                if (parsed.event !== 'canboatjs:rawoutput' && parsed.event !== 'canboatjs:rawsend') {
                    return;
                }
                // Don't process data if parser is not ready yet
                if (!parserRef.current) {
                    return;
                }
                if (filterOptionsRef.current?.pauseUpdates) {
                    return;
                }
                let pgn = undefined;
                if (parserRef.current) {
                    pgn = parserRef.current.parse(parsed.event === 'canboatjs:rawsend' ? parsed.data.data : parsed.data);
                }
                if (pgn !== undefined) {
                    //console.log('pgn', pgn)
                    pgn.timestamp = new Date().toISOString();
                    if (parsed.event === 'canboatjs:rawsend') {
                        ;
                        pgn.sent = true;
                        if (parsed.data.knownSrc !== true) {
                            pgn.src = 256;
                        }
                    }
                    // Add to pending updates instead of processing immediately
                    pendingDataUpdates.current.push(pgn);
                    // Throttle updates to prevent event loop blocking
                    if (dataUpdateTimeoutRef.current) {
                        clearTimeout(dataUpdateTimeoutRef.current);
                    }
                    // Process updates after a short delay to batch them
                    dataUpdateTimeoutRef.current = setTimeout(() => {
                        processPendingDataUpdates();
                    }, 16); // ~60fps update rate
                }
            }
            catch (error) {
                console.error('Error parsing WebSocket message:', error);
            }
        };
        const connectWebSocket = () => {
            try {
                if (isEmbedded) {
                    // Use SignalK admin UI WebSocket in embedded mode
                    webSocket = props.adminUI.openWebsocket({
                        subscribe: 'none',
                        events: 'canboatjs:rawoutput,canboatjs:rawsend,recording:started,recording:stopped,recording:progress,recording:error',
                    });
                    // Set connection status for embedded mode - assume connected if websocket was created
                    setConnectionStatus({
                        isConnected: true,
                        lastUpdate: new Date().toISOString(),
                        error: undefined,
                    });
                    webSocket.onmessage = (x) => {
                        handleWebSocketMessage(x.data);
                    };
                    // Add error handling for embedded WebSocket if possible
                    if (webSocket.onerror) {
                        webSocket.onerror = (error) => {
                            console.error('Embedded WebSocket error:', error);
                            setConnectionStatus((prev) => ({
                                isConnected: false,
                                lastUpdate: new Date().toISOString(),
                                error: 'SignalK WebSocket connection error',
                            }));
                        };
                    }
                    if (webSocket.onclose) {
                        webSocket.onclose = () => {
                            console.log('Embedded WebSocket disconnected');
                            setConnectionStatus((prev) => ({
                                isConnected: false,
                                lastUpdate: new Date().toISOString(),
                                error: 'SignalK WebSocket connection closed',
                            }));
                        };
                    }
                }
                else {
                    // Use direct WebSocket connection in standalone mode
                    webSocket = new WebSocket(`ws://${window.location.host}`);
                    webSocket.onopen = () => {
                        console.log('WebSocket connection established');
                        setConnectionStatus({
                            isConnected: true,
                            lastUpdate: new Date().toISOString(),
                            error: undefined,
                        });
                        // Subscribe to connection events
                        webSocket?.send(JSON.stringify({
                            type: 'subscribe',
                            subscription: 'status',
                        }));
                    };
                    webSocket.onmessage = (event) => {
                        handleWebSocketMessage(event.data);
                    };
                    webSocket.onclose = () => {
                        console.log('WebSocket disconnected');
                        setConnectionStatus((prev) => ({
                            isConnected: false,
                            lastUpdate: new Date().toISOString(),
                            error: 'WebSocket connection closed',
                        }));
                        // Attempt to reconnect after a delay in standalone mode
                        if (reconnectTimeout) {
                            clearTimeout(reconnectTimeout);
                        }
                        reconnectTimeout = setTimeout(connectWebSocket, 3000);
                    };
                    webSocket.onerror = (error) => {
                        console.error('WebSocket error:', error);
                        setConnectionStatus((prev) => ({
                            isConnected: false,
                            lastUpdate: new Date().toISOString(),
                            error: 'WebSocket connection error occurred',
                        }));
                    };
                }
            }
            catch (error) {
                console.error('Failed to create WebSocket:', error);
                setConnectionStatus((prev) => ({
                    isConnected: false,
                    lastUpdate: new Date().toISOString(),
                    error: `Failed to create WebSocket connection: ${error instanceof Error ? error.message : 'Unknown error'}`,
                }));
                if (!isEmbedded && reconnectTimeout) {
                    clearTimeout(reconnectTimeout);
                }
                if (!isEmbedded) {
                    reconnectTimeout = setTimeout(connectWebSocket, 3000);
                }
            }
        };
        connectWebSocket();
        setWs(webSocket);
        return () => {
            if (reconnectTimeout) {
                clearTimeout(reconnectTimeout);
            }
            if (dataUpdateTimeoutRef.current) {
                clearTimeout(dataUpdateTimeoutRef.current);
            }
            if (webSocket) {
                if (isEmbedded) {
                    // SignalK WebSocket might have a different close method
                    try {
                        webSocket.close?.();
                    }
                    catch (e) {
                        console.warn('Failed to close SignalK WebSocket:', e);
                    }
                }
                else {
                    webSocket.close();
                }
            }
        };
    }, [isEmbedded]);
    // Initialize filter settings from localStorage on component mount
    (0, react_1.useEffect)(() => {
        const savedSettings = localStorage_1.storageOperations.loadFilterSettings();
        if (savedSettings) {
            filter.next(savedSettings.filter);
            doFiltering.next(savedSettings.doFiltering);
            filterOptions.next(savedSettings.filterOptions);
        }
        else {
            // Set default values if no saved settings
            filter.next({});
            doFiltering.next(false);
            filterOptions.next({
                //useCamelCase: true,
                showUnknownProprietaryPGNsOnSeparateLines: false,
                showPgn126208OnSeparateLines: false,
                showInfoPgns: false,
                maxHistorySize: 10,
            });
        }
    }, []);
    // Save filter settings to localStorage when they change
    (0, react_1.useEffect)(() => {
        const subscription = (0, rxjs_1.combineLatest)([filter, doFiltering, filterOptions]).subscribe(([filterValue, doFilteringValue, filterOptionsValue]) => {
            localStorage_1.storageOperations.saveFilterSettings({
                filter: filterValue,
                doFiltering: doFilteringValue,
                filterOptions: filterOptionsValue,
            });
        });
        return () => {
            subscription.unsubscribe();
        };
    }, []);
    /*
    const dinfo = useObservableState<DeviceMap>(deviceInfo, {})
    const selectedPgnValue = useObservableState<PGN | undefined>(selectedPgn, undefined)
    const info = selectedPgnValue ? dinfo[selectedPgnValue.src!] : { src: 0, info: {} }
  */
    // Show loading spinner while checking authentication in embedded mode
    if (isEmbedded && authStatus.loading) {
        return ((0, jsx_runtime_1.jsx)("div", { className: "d-flex justify-content-center align-items-center", style: { minHeight: '200px' }, children: (0, jsx_runtime_1.jsxs)("div", { className: "text-center", children: [(0, jsx_runtime_1.jsx)("div", { className: "spinner-border text-primary mb-3", role: "status", children: (0, jsx_runtime_1.jsx)("span", { className: "sr-only", children: "Loading..." }) }), (0, jsx_runtime_1.jsx)("p", { children: "Checking authentication..." })] }) }));
    }
    // Show error message if authentication failed in embedded mode
    if (isEmbedded && !authStatus.isAuthenticated) {
        return ((0, jsx_runtime_1.jsx)("div", { className: "container-fluid mt-4", children: (0, jsx_runtime_1.jsxs)("div", { className: "alert alert-danger", role: "alert", children: [(0, jsx_runtime_1.jsxs)("h4", { className: "alert-heading", children: [(0, jsx_runtime_1.jsx)("i", { className: "fas fa-exclamation-triangle" }), " Access Denied"] }), (0, jsx_runtime_1.jsx)("p", { className: "mb-0", children: !authStatus.isAuthenticated
                            ? 'You must be logged in to access the Visual Analyzer.'
                            : 'Admin privileges are required to access the Visual Analyzer.' }), authStatus.error && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("hr", {}), (0, jsx_runtime_1.jsxs)("p", { className: "mb-0 small text-muted", children: ["Error: ", authStatus.error] })] })), (0, jsx_runtime_1.jsx)("hr", {}), (0, jsx_runtime_1.jsxs)("p", { className: "mb-0", children: ["Please ", !authStatus.isAuthenticated ? 'log in' : 'contact your system administrator', " and try again."] })] }) }));
    }
    return ((0, jsx_runtime_1.jsxs)("div", { children: [!connectionStatus.isConnected && ((0, jsx_runtime_1.jsx)("div", { className: "alert alert-danger mb-3", role: "alert", children: (0, jsx_runtime_1.jsxs)("div", { className: "d-flex align-items-center", children: [(0, jsx_runtime_1.jsx)("i", { className: "fas fa-exclamation-triangle me-2" }), (0, jsx_runtime_1.jsxs)("div", { className: "flex-grow-1", children: [(0, jsx_runtime_1.jsx)("strong", { children: "Connection Error" }), connectionStatus.error && ((0, jsx_runtime_1.jsxs)("div", { className: "mt-1 small", children: [(0, jsx_runtime_1.jsx)("strong", { children: "Details:" }), " ", connectionStatus.error] })), (0, jsx_runtime_1.jsxs)("div", { className: "mt-1 small text-muted", children: ["Last update: ", new Date(connectionStatus.lastUpdate).toLocaleString()] })] }), (0, jsx_runtime_1.jsx)("div", { className: "ms-2", children: (0, jsx_runtime_1.jsx)("span", { className: "badge bg-danger", children: "Disconnected" }) })] }) })), (0, jsx_runtime_1.jsxs)("div", { className: "d-flex align-items-center justify-content-between mb-2", children: [(0, jsx_runtime_1.jsxs)(reactstrap_1.Nav, { tabs: true, children: [(0, jsx_runtime_1.jsx)(reactstrap_1.NavItem, { children: (0, jsx_runtime_1.jsx)(reactstrap_1.NavLink, { className: activeTab === ANALYZER_TAB_ID ? 'active' : '', onClick: () => handleTabChange(ANALYZER_TAB_ID), style: { cursor: 'pointer' }, children: "NMEA 2000 Analyzer" }) }), (0, jsx_runtime_1.jsx)(reactstrap_1.NavItem, { children: (0, jsx_runtime_1.jsx)(reactstrap_1.NavLink, { className: activeTab === SEND_TAB_ID ? 'active' : '', onClick: () => handleTabChange(SEND_TAB_ID), style: { cursor: 'pointer' }, children: "Send" }) }), (0, jsx_runtime_1.jsx)(reactstrap_1.NavItem, { children: (0, jsx_runtime_1.jsx)(reactstrap_1.NavLink, { className: activeTab === TRANSFORM_TAB_ID ? 'active' : '', onClick: () => handleTabChange(TRANSFORM_TAB_ID), style: { cursor: 'pointer' }, children: "Transform" }) }), (0, jsx_runtime_1.jsx)(reactstrap_1.NavItem, { children: (0, jsx_runtime_1.jsx)(reactstrap_1.NavLink, { className: activeTab === PGN_BROWSER_TAB_ID ? 'active' : '', onClick: () => handleTabChange(PGN_BROWSER_TAB_ID), style: { cursor: 'pointer' }, children: "PGN Browser" }) }), (0, jsx_runtime_1.jsx)(reactstrap_1.NavItem, { children: (0, jsx_runtime_1.jsx)(reactstrap_1.NavLink, { className: activeTab === EDITING_TAB_ID ? 'active' : '', onClick: () => handleTabChange(EDITING_TAB_ID), style: { cursor: 'pointer' }, children: "Editing" }) }), (0, jsx_runtime_1.jsx)(reactstrap_1.NavItem, { children: (0, jsx_runtime_1.jsx)(reactstrap_1.NavLink, { className: activeTab === RECORDING_TAB_ID ? 'active' : '', onClick: () => handleTabChange(RECORDING_TAB_ID), style: { cursor: 'pointer' }, children: "Recording" }) }), !isEmbedded && ((0, jsx_runtime_1.jsx)(reactstrap_1.NavItem, { children: (0, jsx_runtime_1.jsx)(reactstrap_1.NavLink, { className: activeTab === CONNECTIONS_TAB_ID ? 'active' : '', onClick: () => handleTabChange(CONNECTIONS_TAB_ID), style: { cursor: 'pointer' }, children: "Connections" }) }))] }), (0, jsx_runtime_1.jsx)("div", { className: "d-flex align-items-center gap-2", children: (0, jsx_runtime_1.jsx)("span", { className: `badge ${connectionStatus.isConnected ? 'bg-success' : 'bg-danger'}`, title: connectionStatus.error || 'Connection status', children: connectionStatus.isConnected ? 'Connected' : 'Disconnected' }) })] }), (0, jsx_runtime_1.jsxs)(reactstrap_1.TabContent, { activeTab: activeTab, children: [(0, jsx_runtime_1.jsx)(reactstrap_1.TabPane, { tabId: ANALYZER_TAB_ID, children: (0, jsx_runtime_1.jsx)(reactstrap_1.Card, { children: (0, jsx_runtime_1.jsx)(reactstrap_1.CardBody, { children: (0, jsx_runtime_1.jsxs)("div", { id: "content", children: [(0, jsx_runtime_1.jsx)(reactstrap_1.Row, { children: (0, jsx_runtime_1.jsx)(reactstrap_1.Col, { xs: "24", md: "12", children: (0, jsx_runtime_1.jsx)(Filters_1.FilterPanel, { doFiltering: doFiltering, filter: filter, filterOptions: filterOptions, availableSrcs: availableSrcs, deviceInfo: deviceInfo }) }) }), (0, jsx_runtime_1.jsxs)(reactstrap_1.Row, { children: [showDataList && ((0, jsx_runtime_1.jsx)(reactstrap_1.Col, { xs: "12", md: "6", children: (0, jsx_runtime_1.jsx)(DataList_1.DataList, { data: data, filter: filter, doFiltering: doFiltering, filterOptions: filterOptions, onRowClicked: (row) => {
                                                            const rowKey = (0, exports.getRowKey)(row, filterOptionsRef.current || undefined);
                                                            setSelectedPgnKey(rowKey);
                                                            selectedPgn.next(row);
                                                            // Find the entry in the current list to get the history
                                                            const entry = list[rowKey];
                                                            if (entry) {
                                                                selectedPgnWithHistory.next({
                                                                    current: row,
                                                                    history: entry.history,
                                                                });
                                                            }
                                                            else {
                                                                selectedPgnWithHistory.next({
                                                                    current: row,
                                                                    history: [],
                                                                });
                                                            }
                                                        } }) })), (0, jsx_runtime_1.jsx)(reactstrap_1.Col, { xs: "12", md: showDataList ? '6' : '12', children: (0, jsx_runtime_1.jsx)(SentencePanel_1.SentencePanel, { selectedPgn: selectedPgn, selectedPgnWithHistory: selectedPgnWithHistory, onEditPgn: handleEditPgn, inEditingTab: false, info: deviceInfo }) })] })] }) }) }) }), (0, jsx_runtime_1.jsx)(reactstrap_1.TabPane, { tabId: SEND_TAB_ID, children: (0, jsx_runtime_1.jsx)(SendTab_1.SendTab, {}) }), (0, jsx_runtime_1.jsx)(reactstrap_1.TabPane, { tabId: TRANSFORM_TAB_ID, children: (0, jsx_runtime_1.jsx)(TransformTab_1.default, { isEmbedded: isEmbedded }) }), (0, jsx_runtime_1.jsx)(reactstrap_1.TabPane, { tabId: PGN_BROWSER_TAB_ID, children: (0, jsx_runtime_1.jsx)(PgnBrowser_1.PgnBrowser, { onEditPgn: handleEditPgn }) }), (0, jsx_runtime_1.jsx)(reactstrap_1.TabPane, { tabId: EDITING_TAB_ID, children: (0, jsx_runtime_1.jsx)(EditorTab_1.default, { isEmbedded: isEmbedded, deviceInfo: deviceInfo }) }), (0, jsx_runtime_1.jsx)(reactstrap_1.TabPane, { tabId: RECORDING_TAB_ID, children: (0, jsx_runtime_1.jsx)(RecordingTab_1.default, {}) }), !isEmbedded && ((0, jsx_runtime_1.jsx)(reactstrap_1.TabPane, { tabId: CONNECTIONS_TAB_ID, children: (0, jsx_runtime_1.jsx)(ConnectionManagerPanel_1.ConnectionManagerPanel, { connectionStatus: connectionStatus, onStatusUpdate: setConnectionStatus }) }))] })] }));
};
function requestMetaData(dst) {
    console.log(`Requesting metadata for source ${dst}`);
    const pgnDataList = infoPGNS.map((num) => {
        const pgn = new ts_pgns_1.PGN_59904({ pgn: num }, dst);
        return pgn;
    });
    // Use the centralized service to send multiple metadata requests
    services_1.server.post({ type: 'send-n2k', values: pgnDataList }).catch((error) => {
        console.error(`Failed to complete metadata requests for destination ${dst}:`, error);
    });
}
const AppPanel = (props) => {
    return ((0, jsx_runtime_1.jsx)(RecordingContext_1.RecordingProvider, { children: (0, jsx_runtime_1.jsx)(AppPanelInner, { ...props }) }));
};
exports.default = AppPanel;
